(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vk-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vs-product'))customElements.define('vs-product',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.initGallery();this.addEventListener('click',e=>{const b=e.target.closest('[data-slide]');if(!b)return;this.show(b.dataset.slide)});this.addEventListener('change',e=>{if(e.target.closest('.vs-native-choice'))this.update()});this.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('.vs-slide');if(slide)this.show(slide.dataset.index)});this.addEventListener('click',e=>{if(e.target.closest('[data-buy]'))this.addToCart(e)},true);this.addEventListener('submit',e=>this.addToCart(e));this.update()}initGallery(){
  this.gallerySlides=Array.from(this.querySelectorAll('.vs-slide'));
  this.galleryStage=this.querySelector('.vs-gallery-stage');
  this.galleryIndex=Math.max(0,this.gallerySlides.findIndex(slide=>!slide.hidden));
  this.galleryTarget=this.galleryIndex;
  this.galleryRequest=0;
  if(!this.galleryStage)return;
  const multiple=this.gallerySlides.length>1;
  this.querySelectorAll('.vs-gallery-arrow').forEach(button=>button.hidden=!multiple);
  this.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>this.moveGallery(-1));
  this.querySelector('[data-gallery-next]')?.addEventListener('click',()=>this.moveGallery(1));
  this.querySelector('.vs-gallery-inner').addEventListener('keydown',event=>{
    if(!multiple||!['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();this.moveGallery(event.key==='ArrowRight'?1:-1);
  });
  this.galleryStage.addEventListener('pointerdown',event=>{
    if(!multiple||event.pointerType==='mouse'||!event.isPrimary||event.target.closest('button'))return;
    this.galleryTouch={id:event.pointerId,x:event.clientX,y:event.clientY};
    this.galleryStage.setPointerCapture(event.pointerId);
  });
  this.galleryStage.addEventListener('pointerup',event=>{
    const start=this.galleryTouch;this.galleryTouch=null;
    if(!start||start.id!==event.pointerId)return;
    const dx=event.clientX-start.x,dy=event.clientY-start.y;
    if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.3)this.moveGallery(dx<0?1:-1);
  });
  this.galleryStage.addEventListener('pointercancel',()=>this.galleryTouch=null);
  this.prepareGalleryImage(this.galleryIndex).then(()=>this.warmGallery());
}
async prepareGalleryImage(index){
  const image=this.gallerySlides[index]?.querySelector('img');
  if(!image)return true;
  image.loading='eager';
  if(!image.complete){
    await new Promise(resolve=>{
      const finish=()=>{image.removeEventListener('load',finish);image.removeEventListener('error',finish);resolve()};
      image.addEventListener('load',finish,{once:true});image.addEventListener('error',finish,{once:true});
      if(image.complete)finish();
    });
  }
  if(!image.naturalWidth)return false;
  if(image.decode){try{await image.decode()}catch(error){return image.complete&&image.naturalWidth>0}}
  return true;
}
warmGallery(){
  const count=this.gallerySlides.length;
  if(count<2)return;
  this.prepareGalleryImage((this.galleryIndex+1)%count);
  this.prepareGalleryImage((this.galleryIndex+count-1)%count);
}
moveGallery(direction){
  const count=this.gallerySlides.length;
  if(count>1)this.show((this.galleryTarget+direction+count)%count);
}
async show(index){
  const next=Number(index);
  if(!Number.isInteger(next)||!this.gallerySlides?.[next])return;
  this.galleryTarget=next;
  const request=++this.galleryRequest;
  this.galleryStage.setAttribute('aria-busy','true');
  const ready=await this.prepareGalleryImage(next);
  if(request!==this.galleryRequest)return;
  this.galleryStage.removeAttribute('aria-busy');
  const status=this.querySelector('[data-gallery-status]');
  if(!ready){this.galleryTarget=this.galleryIndex;if(status)status.textContent='Image unavailable. Please try another photo.';return}
  this.gallerySlides.forEach((slide,i)=>slide.hidden=i!==next);
  this.querySelectorAll('[data-slide]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.slide)===next)));
  this.galleryIndex=next;
  if(status)status.textContent='Image '+(next+1)+' of '+this.gallerySlides.length;
  const thumb=this.querySelector('[data-slide="'+next+'"]');
  if(thumb){const strip=thumb.parentElement;const a=thumb.getBoundingClientRect(),b=strip.getBoundingClientRect();if(a.left<b.left||a.right>b.right)strip.scrollLeft+=a.left-b.left-(b.width-a.width)/2}
  this.warmGallery();
}async addToCart(event){
  const form=event.target.closest('form');
  if(!(form instanceof HTMLFormElement)||!form.querySelector('[data-buy]'))return;

  event.preventDefault();
  event.stopImmediatePropagation();
  if(this.adding)return;
  const buy=form.querySelector('[data-buy]');
  if(buy.disabled)return;
  const error=form.querySelector('[data-cart-error]');
  const fields=new FormData(form);
  let requestBody=fields, requestUrl=this.dataset.cartAddUrl, requestHeaders={Accept:'application/json'};
  const moon=this.querySelector('moonbundle-component');
  if(moon){
    try{
      const bundle=JSON.parse(moon.getAttribute('bundle'));
      const config=bundle.configs?.find(c=>c.offers?.length) || bundle;
      const visibleOffers=config.offers.filter(o=>!o.hidden);
      const cards=Array.from(moon.querySelectorAll('.moonbundle-option'));
      const selectedIndex=cards.findIndex(c=>c.classList.contains('moonbundle-option-active'));
      const offer=visibleOffers[selectedIndex];
      if(!offer)throw new Error('Please choose an offer.');
      const mainVariant=Number(fields.get('id'));
      const common={offer_id:offer.id,bundle_id:bundle.id,config_id:config.id,main_product_id:Number(fields.get('product-id')),market_added:this.dataset.currency==='USD'?'US':null,type:'bundle'};
      const items=offer.multiProduct?.slots?.length ? offer.multiProduct.slots.map(slot=>{
        const product=slot.product;
        const id=product.id==='previewProduct'?mainVariant:Number(String(product.variants?.[0]?.id).split('/').pop());
        if(!id)throw new Error('This offer is temporarily unavailable. Please try again.');
        return {id,quantity:Number(product.quantity||slot.quantity||1),properties:{__moonbundle:JSON.stringify({...common,slot_id:slot.id})}};
      }) : [{id:mainVariant,quantity:Number(offer.qty||1),properties:{__moonbundle:JSON.stringify(common)}}];
      requestBody=JSON.stringify({items});
      requestHeaders['Content-Type']='application/json';
      requestUrl+=(requestUrl.includes('?')?'&':'?')+'moonbundle_ignore=true';
    }catch(problem){
      if(error){error.textContent=problem.message;error.hidden=false}
      return;
    }
  }
  this.adding=true;
  buy.disabled=true;
  buy.setAttribute('aria-busy','true');
  const label=buy.textContent;
  buy.textContent=buy.dataset.loadingLabel;
  if(error){error.hidden=true;error.textContent=''}
  let added=false;
  try{
    const response=await fetch(requestUrl,{method:'POST',headers:requestHeaders,body:requestBody});
    const result=await response.json();
    if(!response.ok||result.status)throw new Error(result.description||result.message||'Impossible d’ajouter le coussin. Veuillez réessayer.');
    added=true;
    const drawer=document.querySelector('moonbundle-cart-drawer-block');
    if(drawer&&typeof drawer.open==='function')await drawer.open(true);
    else window.location.assign(this.dataset.cartUrl);
  }catch(problem){
    if(added){window.location.assign(this.dataset.cartUrl);return}
    const drawer=document.querySelector('moonbundle-cart-drawer-block');
    if(drawer&&typeof drawer.close==='function')drawer.close();
    if(error){error.textContent=problem.message||'Impossible d’ajouter le coussin. Veuillez réessayer.';error.hidden=false}
  }finally{
    this.adding=false;
    buy.disabled=false;
    buy.removeAttribute('aria-busy');
    buy.textContent=label;
    this.update();
  }
}
update(){if(this.querySelector('.moonbundle-box'))return;const select=this.querySelector('select[name=id]');if(!select)return;const option=select.selectedOptions[0],qty=this.querySelector('input[name=quantity]'),checked=this.querySelector('.vs-offers input:checked');if(qty)qty.value=checked?.value||1;const buy=this.querySelector('[data-buy]');if(buy){buy.disabled=option?.dataset.available!=='true';buy.textContent=buy.disabled?buy.dataset.soldLabel:buy.dataset.availableLabel}const currency=this.dataset.currency||'EUR';const mainPrice=this.querySelector('[data-current-price]');if(mainPrice)mainPrice.textContent=new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency}).format(Number(option?.dataset.price||0)/100);this.querySelectorAll('[data-offer-price]').forEach(p=>{p.textContent=new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency}).format(Number(option?.dataset.price||0)*Number(p.dataset.offerPrice)/100)})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vs-product'))customElements.define('vs-product',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',e=>{const b=e.target.closest('[data-slide]');if(!b)return;this.show(b.dataset.slide)});this.addEventListener('change',e=>{if(e.target.closest('.vs-native-choice'))this.update()});this.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('.vs-slide');if(slide)this.show(slide.dataset.index)});this.update()}show(index){this.querySelectorAll('.vs-slide').forEach(x=>x.hidden=x.dataset.index!==index);this.querySelectorAll('[data-slide]').forEach(x=>x.setAttribute('aria-pressed',String(x.dataset.slide===index)))}update(){if(this.querySelector('.moonbundle-box'))return;const select=this.querySelector('select[name=id]');if(!select)return;const option=select.selectedOptions[0],qty=this.querySelector('input[name=quantity]'),checked=this.querySelector('.vs-offers input:checked');if(qty)qty.value=checked?.value||1;const buy=this.querySelector('[data-buy]');if(buy){buy.disabled=option?.dataset.available!=='true';buy.textContent=buy.disabled?buy.dataset.soldLabel:buy.dataset.availableLabel}const currency=this.dataset.currency||'EUR';this.querySelectorAll('[data-offer-price]').forEach(p=>{p.textContent=new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency}).format(Number(option?.dataset.price||0)*Number(p.dataset.offerPrice)/100)})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vs-reviews'))customElements.define('vs-reviews',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',e=>{const b=e.target.closest('[data-category]');if(!b)return;this.querySelectorAll('[data-category]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));let n=0;this.querySelectorAll('[data-review-category]').forEach(c=>{c.hidden=!!b.dataset.category&&c.dataset.reviewCategory!==b.dataset.category;if(!c.hidden)n++});this.querySelector('[data-empty]').hidden=n>0});this.addEventListener('shopify:block:select',()=>{this.querySelector('[data-category]')?.click()})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-sticky"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vs-sticky'))customElements.define('vs-sticky',class extends HTMLElement{connectedCallback(){this.target=this.dataset.target?.startsWith('#')?document.getElementById(this.dataset.target.slice(1)):document.querySelector('vs-product');if(!this.target)return;this.observer=new IntersectionObserver(([e])=>this.toggleAttribute('data-visible',!e.isIntersecting&&e.boundingClientRect.bottom<0),{threshold:0});this.observer.observe(this.target)}disconnectedCallback(){this.observer?.disconnect()}});

  } catch(e) { console.error(e); }
})();
})();
